import { render, staticRenderFns } from "./manage-alert-member.vue?vue&type=template&id=2504c35a&scoped=true"
import script from "./manage-alert-member.vue?vue&type=script&lang=js"
export * from "./manage-alert-member.vue?vue&type=script&lang=js"
import style0 from "./manage-alert-member.vue?vue&type=style&index=0&id=2504c35a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2504c35a",
  null
  
)

export default component.exports